import { Injectable } from '@angular/core';

import { grpcOperator } from '@lyra/app/core/api/grpc/pipe-operators/grpc';
import { MainApi } from '@mark/web-contracts';
import { from } from 'rxjs';

import { GRpcRequestType } from '../grpc-class.type';
import { GrpcCommonService } from './common.service';

export type ICreate = GRpcRequestType<MainApi.UserTreatmentsScheduleGrpcContractClient['Create']>;

@Injectable()
export class UserTreatmentsScheduleGrpcContractService extends GrpcCommonService<MainApi.UserTreatmentsScheduleGrpcContractClient> {
  constructor(protected _GrpcContract: MainApi.UserTreatmentsScheduleGrpcContractClient) {
    super();
  }

  create(request: ICreate) {
    return from(
      this._GrpcContract.Create(
        new MainApi.CreateOrUpdateTreatmentsScheduleWpcRequest(
          MainApi.CreateOrUpdateTreatmentsScheduleWpcRequest.fromObject(request),
        ),
        this.getMetadata(),
      ),
    ).pipe(grpcOperator());
  }
}
